// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-1Kkt-","btnDetail":"index-btnDetail-Z9y4E"};